import haveAside from "@/pages/views/layout/first-router/haveAside";
import noAside from "@/pages/views/layout/first-router/noAside";
let Routers = [
  // 项目概况
  {
    name: "项目概况",
    path: "/project-overview",
    component: noAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "设备地图",
        path: "/project-overview/map",
        component: () => import("@/pages/views/projectOverview/map"),
        meta: {
          auth: true
        }
      },
      {
        name: "项目地图",
        path: "/project-overview/project-map",
        component: () => import("@/pages/views/projectOverview/project-map"),
        meta: {
          auth: true
        }
      },
      {
        name: "项目设备",
        path: "/project-overview/project-device",
        component: () => import("@/pages/views/projectOverview/project-device"),
        meta: {
          auth: true
        }
      },
      {
        name: "全项目驾驶舱",
        path: "/project-overview/cockpit",
        component: () => import("@/pages/views/projectOverview/cockpit"),
        meta: {
          auth: true
        }
      }
    ]
  },

  // 个人中心
  {
    name: "个人中心",
    path: "/personal-center",
    component: noAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "空白",
        path: "/empty",
        component: () => import("@/pages/views/personalCenter/empty"),
        meta: {
          auth: true
        }
      },
      {
        name: "个人信息",
        path: "/personal-info",
        component: () => import("@/pages/views/personalCenter/personal-info"),
        meta: {
          auth: true
        }
      },
      {
        name: "修改密码",
        path: "/change-password",
        component: () => import("@/pages/views/personalCenter/change-password"),
        meta: {
          auth: true
        }
      }
    ]
  },

  // 设备管理
  {
    name: "设备管理",
    path: "/device-management",
    component: haveAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "设备监控",
        path: "device-monitor",
        component: () =>
          import("@/pages/views/deviceManage/deviceOverview/device-overview"),
        meta: {
          auth: true
        }
      },
      {
        name: "消防监控",
        path: "fire-monitor",
        component: () =>
          import("@/pages/views/deviceManage/fireOverview/fire-monitor"),
        meta: {
          auth: true
        }
      },
      {
        name: "门禁控制",
        path: "access-control",
        component: () =>
          import("@/pages/views/deviceManage/AccessManage/access-control"),
        meta: {
          auth: true
        }
      },
      {
        name: "通行记录",
        path: "access-records",
        component: () =>
          import("@/pages/views/deviceManage/AccessManage/access-records"),
        meta: {
          auth: true
        }
      },
      {
        name: "水质实时监测",
        path: "water-realtime",
        component: () =>
          import("@/pages/views/deviceManage/waterMonitor/water-realtime"),
        meta: {
          auth: false
        }
      },
      {
        name: "水质异常报警",
        path: "water-abnormal",
        component: () =>
          import("@/pages/views/deviceManage/waterMonitor/water-abnormal"),
        meta: {
          auth: false
        }
      },
      {
        name: "视频监控",
        path: "monitoring-video",
        component: () => import("@/pages/views/deviceManage/monitoring-video"),
        meta: {
          auth: true
        }
      },
      {
        name: "数据综合监测",
        path: "data-monitor",
        component: () => import("@/pages/views/deviceManage/data-monitor"),
        meta: {
          auth: true
        }
      }
    ]
  },

  // 运维管理
  {
    name: "运维管理",
    path: "/operation-management",
    component: haveAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "APP版本管理",
        path: "version-management",
        component: () =>
          import("@/pages/views/operation-management/version-management"),
        meta: {
          auth: true
        }
      },
      {
        name: "APP版本",
        path: "add-version",
        component: () =>
          import("@/pages/views/operation-management/add-version"),
        meta: {
          auth: true
        }
      },
      {
        name: "客服管理",
        path: "service-management",
        component: () =>
          import("@/pages/views/operation-management/service-management"),
        meta: {
          auth: true
        }
      },
      {
        name: "banner",
        path: "banner-management",
        component: () => import("@/pages/views/operation-management/banner"),
        meta: {
          auth: true
        }
      }
    ]
  },

  // 用户管理
  {
    name: "用户管理",
    path: "/user-manage",
    component: haveAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "用户列表",
        path: "user-list",
        component: () => import("@/pages/views/staffManage/vue/list"),
        meta: {
          auth: true
        }
      },
      {
        name: "添加或编辑用户",
        path: "staff-list/add-staff",
        component: () => import("@/pages/views/staffManage/vue/add-edit-staff"),
        meta: {
          auth: true
        }
      },
      {
        name: "员工信息详情",
        path: "staff-list/staff-detail",
        component: () => import("@/pages/views/staffManage/vue/staff-detail"),
        meta: {
          auth: true
        }
      },
      {
        name: "角色管理",
        path: "role-list",
        component: () =>
          import("@/pages/views/staffManage/roleManagement/role-list"),
        meta: {
          auth: true
        }
      },
      {
        name: "新增/编辑角色",
        path: "role-list/add-edit-role",
        component: () =>
          import("@/pages/views/staffManage/roleManagement/add-edit-role"),
        meta: {
          auth: true,
          parentnode: { "role-list": "/role-list" }
        }
      },
      {
        name: "功能权限",
        path: "role-list/menu-permission",
        component: () =>
          import("@/pages/views/staffManage/roleManagement/menu-permission"),
        meta: {
          auth: true,
          parentnode: { "role-list": "/role-list" }
        }
      },
      {
        name: "设备权限",
        path: "role-list/device-permission",
        component: () =>
          import("@/pages/views/staffManage/roleManagement/device-permission"),
        meta: {
          auth: true,
          parentnode: { "role-list": "/role-list" }
        }
      },
      {
        name: "监控门禁权限",
        path: "role-list/other-permission",
        component: () =>
          import("@/pages/views/staffManage/roleManagement/other-permission"),
        meta: {
          auth: true,
          parentnode: { "role-list": "/role-list" }
        }
      },
      {
        name: "大华",
        path: "role-list/other-permission1",
        component: () =>
          import("@/pages/views/staffManage/roleManagement/other-permission1"),
        meta: {
          auth: true,
          parentnode: { "role-list": "/role-list" }
        }
      },
      {
        name: "日志管理",
        path: "log-management",
        component: () => import("@/pages/views/staffManage/log-management"),
        meta: {
          auth: true,
          parentnode: { "role-list": "/role-list" }
        }
      }
    ]
  },

  // 能耗管理
  {
    name: "能耗管理",
    path: "/energy-management",
    component: haveAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "能耗统计",
        path: "/energy-management/energy-statistics",
        component: () =>
          import("@/pages/views/energyConsumption/energy-statistics"),
        meta: {
          auth: true
        }
      },
      {
        name: "数据导出222",
        path: "/energy-management/energy-export",
        component: () => import("@/pages/views/energyConsumption/data-export"),
        meta: {
          auth: true
        }
      }
    ]
  },

  // 维保管理
  {
    name: "维保管理",
    path: "/maintain-management",
    component: haveAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "maintain-list",
        path: "maintain-list",
        component: () => import("@/pages/views/maintenance/maintain-list"),
        meta: {
          auth: true
        }
      },
      {
        name: "waiting-list",
        path: "waiting-list",
        component: () => import("@/pages/views/maintenance/waiting-list"),
        meta: {
          auth: true
        }
      },
      {
        name: "my-list",
        path: "my-list",
        component: () => import("@/pages/views/maintenance/my-list"),
        meta: {
          auth: true
        }
      },

      {
        name: "add-task",
        path: "add-task",
        component: () => import("@/pages/views/maintenance/add-task"),
        meta: {
          auth: true
        }
      },
      {
        name: "task-detail",
        path: "task-detail",
        component: () => import("@/pages/views/maintenance/task-detail"),
        meta: {
          auth: true
        }
      },
      {
        name: "dispose",
        path: "task-dispose",
        component: () => import("@/pages/views/maintenance/dispose"),
        meta: {
          auth: true
        }
      },
      {
        name: "all",
        path: "all-list",
        component: () => import("@/pages/views/maintenance/all-list"),
        meta: {
          auth: true
        }
      }
    ]
  },

  // 报警管理
  {
    name: "报警管理",
    path: "/alarm-management",
    component: haveAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "实时报警",
        path: "alarm-list",
        component: () => import("@/pages/views/alarmManage/alarm-list"),
        meta: {
          auth: true
        }
      },
      {
        name: "报警分析",
        path: "alarm-analyze",
        component: () => import("@/pages/views/alarmManage/alarm-analyze"),
        meta: {
          auth: true
        }
      },
      {
        name: "故障诊断",
        path: "trouble-list",
        component: () => import("@/pages/views/alarmManage/trouble-list"),
        meta: {
          auth: true
        }
      },
      {
        name: "查看运维建议",
        path: "check-advice",
        component: () => import("@/pages/views/alarmManage/check-advice"),
        meta: {
          auth: true
        }
      }
    ]
  },

  // 设备接入
  {
    name: "设备接入",
    path: "/device-access",
    component: haveAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "产品管理",
        path: "product-manage",
        component: () =>
          import("@/pages/views/deviceAccess/product/product-manage"),
        meta: {
          auth: true
        }
      },
      {
        name: "添加编辑产品",
        path: "add-edit-product",
        component: () =>
          import("@/pages/views/deviceAccess/product/add-edit-product"),
        meta: {
          auth: true
        }
      },
      {
        name: "查看产品",
        path: "check-product",
        component: () =>
          import("@/pages/views/deviceAccess/product/check-product"),
        meta: {
          auth: true
        }
      },

      {
        name: "分公司管理",
        path: "/device-access/filiale-manage",
        component: () =>
          import("@/pages/views/deviceAccess/filiale/filiale-manage"),
        meta: {
          auth: true
        }
      },
      {
        name: "添加编辑分公司",
        path: "/device-access/add-edit-filiale",
        component: () =>
          import("@/pages/views/deviceAccess/filiale/add-edit-filiale"),
        meta: {
          auth: true
        }
      },
      {
        name: "查看分公司",
        path: "check-filiale",
        component: () =>
          import("@/pages/views/deviceAccess/filiale/check-filiale"),
        meta: {
          auth: true
        }
      },
      {
        name: "客户管理11",
        path: "/device-access/client-manage",
        component: () =>
          import("@/pages/views/deviceAccess/client/client-manage"),
        meta: {
          auth: true
        }
      },
      {
        name: "添加编辑客户",
        path: "/device-access/add-edit-client",
        component: () =>
          import("@/pages/views/deviceAccess/client/add-edit-client"),
        meta: {
          auth: true
        }
      },
      {
        name: "查看客户",
        path: "check-client",
        component: () =>
          import("@/pages/views/deviceAccess/client/check-client"),
        meta: {
          auth: true
        }
      },
      {
        name: "项目管理11",
        path: "/device-access/project-manage",
        component: () =>
          import("@/pages/views/deviceAccess/project/project-manage"),
        meta: {
          auth: true
        }
      },
      {
        name: "添加编辑项目",
        path: "/device-access/add-edit-project",
        component: () =>
          import("@/pages/views/deviceAccess/project/add-edit-project"),
        meta: {
          auth: true
        }
      },
      {
        name: "查看项目",
        path: "check-project",
        component: () =>
          import("@/pages/views/deviceAccess/project/check-project"),
        meta: {
          auth: true
        }
      },
      {
        name: "设备模板管理",
        path: "/device-access/template-manage",
        component: () =>
          import("@/pages/views/deviceAccess/template/template-manage"),
        meta: {
          auth: true
        }
      },
      {
        name: "添加编辑模板",
        path: "/device-access/add-edit-template",
        component: () =>
          import("@/pages/views/deviceAccess/template/add-edit-template"),
        meta: {
          auth: true
        }
      },
      {
        name: "查看模板",
        path: "check-template",
        component: () =>
          import("@/pages/views/deviceAccess/template/check-template"),
        meta: {
          auth: true
        }
      },
      {
        name: "设置组态模板",
        path: "set-template",
        component: () =>
          import("@/pages/views/deviceAccess/template/set-template1"),
        meta: {
          auth: true
        }
      },
      {
        name: "设备管理11",
        path: "/device-access/device-manage",
        component: () =>
          import("@/pages/views/deviceAccess/device/device-manage"),
        meta: {
          auth: true
        }
      },
      {
        name: "添加编辑设备",
        path: "/device-access/add-edit-device",
        component: () =>
          import("@/pages/views/deviceAccess/device/add-edit-device"),
        meta: {
          auth: true
        }
      },
      {
        name: "查看设备",
        path: "check-device",
        component: () =>
          import("@/pages/views/deviceAccess/device/check-device"),
        meta: {
          auth: true
        }
      },
      {
        name: "设置报警信息",
        path: "set-warning",
        component: () =>
          import("@/pages/views/deviceAccess/device/set-warning"),
        meta: {
          auth: true
        }
      },
      {
        name: "设置末端试水装置绑定设置",
        path: "set-equipments",
        component: () =>
          import("@/pages/views/deviceAccess/device/set-equipments"),
        meta: {
          auth: true
        }
      },
      {
        name: "设置末端试水装置绑定设置",
        path: "add-equipments",
        component: () =>
          import("@/pages/views/deviceAccess/device/add-equipments"),
        meta: {
          auth: true
        }
      },
      {
        name: "设置末端试水装置分组管理",
        path: "add-Group",
        component: () =>
          import("@/pages/views/deviceAccess/device/add-Group"),
        meta: {
          auth: true
        }
      },
      {
        name: "设置通讯时间",
        path: "set-time",
        component: () => import("@/pages/views/deviceAccess/device/set-time"),
        meta: {
          auth: true
        }
      },
      {
        name: "点位图标管理",
        path: "icon-manage",
        component: () => import("@/pages/views/deviceAccess/icon/icon-manage"),
        meta: {
          auth: true
        }
      },
      {
        name: "消防设备组管理",
        path: "fire-manage",
        component: () =>
          import("@/pages/views/deviceAccess/fireControl/fire-manage"),
        meta: {
          auth: true
        }
      },
      {
        name: "添加设备组",
        path: "add-edit-group",
        component: () =>
          import("@/pages/views/deviceAccess/fireControl/add-edit-group"),
        meta: {
          auth: true
        }
      },
      {
        name: "设置组态",
        path: "fire-manage/set-template",
        component: () =>
          import("@/pages/views/deviceAccess/fireControl/set-template"),
        meta: {
          auth: true
        }
      },
      {
        name: "设备可视化展示设置",
        path: "/device-access/device-point-show",
        component: () =>
          import("@/pages/views/deviceAccess/device-point-show"),
        meta: {
          auth: true
        }
      },
    ]
  },
  // 生命周期管理
  {
    name: "生命周期管理",
    path: "/lifecycle-manage",
    component: haveAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "设备信息查询",
        path: "device-message",
        component: () => import("@/pages/views/lifecycleManage/device-message"),
        meta: {
          auth: true
        }
      },
      {
        name: "查看详情",
        path: "check-details",
        component: () => import("@/pages/views/lifecycleManage/details"),
        meta: {
          auth: true
        }
      }
    ]
  },
  // 数据分析
  {
    name: "数据分析",
    path: "/data-analyze",
    component: haveAside,
    meta: {
      auth: true
    },
    children: [
      {
        name: "数据分析111",
        path: "data-analyze",
        component: () => import("@/pages/views/dataAnalyze/data-analyze"),
        meta: {
          auth: true
        }
      },
      {
        name: "数据导出111",
        path: "data-export",
        component: () => import("@/pages/views/dataAnalyze/data-export"),
        meta: {
          auth: true
        }
      }
    ]
  }
];
export default Routers;



// WEBPACK FOOTER //
// ./src/router/pages1.router.js